import { isNumeric, readNumber } from "../../../core/data-utils";

/**
 * A directive that, when placed within a FlexTable, will map the value
 * to or from the variable reference passed in.
 * @example
 * <table apex-flex-table apex-excel-hotkeys="true">
 *   <tr ng-repeat="item in $ctrl.items"><td apex-flex-cell-model="item.amount">{{ item.amount | number }}</td></tr>
 * </table>
 */
export function FlexCellModelDirective($parse, $timeout) {
    'ngInject';
    return {
        selector: "apexFlexCellModel",
        require: {
            flexTable: "^apexFlexTable",
            form: "^^?form"
        },
        link: function(scope, el, attr, { flexTable, form }) {
            const mapper = {
                getValue: () => scope.$eval(attr.apexFlexCellModel),
                setValue: value => {
                    // Do some safe number coercion since most pasted inputs will need
                    // to be real numbers on the backend.
                    if (isNumeric(value)) {
                        value = readNumber(value);
                    } else {
                        value = value || null;
                    }
                    // Wrap in timeout to ensure it is run during the next available digest.
                    $timeout(() => {
                        $parse(attr.apexFlexCellModel).assign(scope, value);
                        if (attr.apexChange) {
                            try {
                                scope.$eval(attr.apexChange);
                            } catch (ex) {
                                console.error("flex-cell-model apex-change error", ex);
                            }
                        }
                        if (form) {
                            // Integrate with parent forms as if this were an ng-model
                            form.$setDirty();
                        }
                    })
                },
            };
            // Add a mapper used to get or set values for the cell element.
            flexTable.context.registerCellMapper("excelHotkeys", el[0], mapper);
        }
    }
}
